export default __webpack_public_path__ + "static/applogo-8862c9674579cc7a86adcf42b3d443ca.svg";